"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagUnauthorize = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagUnauthorize"));

// Generated by script, don't edit it please.
var TagUnauthorize = (0, _createSvgIcon["default"])({
  as: _TagUnauthorize["default"],
  ariaLabel: 'tag unauthorize',
  category: 'application',
  displayName: 'TagUnauthorize'
});
var _default = TagUnauthorize;
exports["default"] = _default;
module.exports = exports.default;